import Reactor from 'data/reactor';
import { toImmutable, Immutable } from 'nuclear-js';
import StudentGetters from 'data/student/getters';
import RosterGetters from 'data/roster/getters';
import RuntimeGetters from 'data/app-runtime/getters';

export const USER_STORE = 'user';
export const PARTNER_STORE = 'partner';
export const ROSTER_STORE = 'roster';
export const RUNTIME_STORE = 'runtime';
// intentionally ommitting the Learning Continuum store

const PYRON_API_BASE_PATH = {

    dev        : 'https://orf01-colo-gateway.nwea.org',
    orf01      : 'https://orf01-colo-gateway.nwea.org',
    int03      : 'https://int03-colo-gateway.nwea.org',
    perf01     : 'https://perf01-colo-gateway.nwea.org',
    production : 'https://colo-gateway.nwea.org'
   };
const getStoreNames = (stores) => {
    // Can accept null (for all stores), string (store name), or array of strings (multiple store names)
    return Array.isArray(stores)
        ? [stores].reduce((a, b) => a.concat(b))
        : !stores
        ? [USER_STORE, PARTNER_STORE, ROSTER_STORE, RUNTIME_STORE]
        : [stores];
};

export const removeOldestStudent = () => {
    let oldestBid = null;
    let oldestTimestamp = Date.now();
    for (var sBid in nweaGlobals.studentArchives) {
        if (
            nweaGlobals.studentArchives[sBid].timestamp > 0 &&
            nweaGlobals.studentArchives[sBid].timestamp < oldestTimestamp
        ) {
            oldestTimestamp = nweaGlobals.studentArchives[sBid].timestamp;
            oldestBid = sBid;
        } // if ((nweaGlobals.studentArchives[sBid].timestamp > 0) && (nweaGlobals.studentArchives[sBid].timestamp < oldestTimestamp))
    } // for (var sBid in nweaGlobals.studentArchives)
    if (oldestBid) {
        console.log('Removing oldest archive: ' + oldestBid);
        nweaGlobals.studentArchives[oldestBid].timestamp = 0; // Indicates that archive is NOT in sessionStorage
        sessionStorage.removeItem(oldestBid);
    }
};

export const saveStores = (storesToSave) => {
    // Can accept null (for all stores), string (store name), or array of strings (multiple store names)
    const storeNames = getStoreNames(storesToSave);
    storeNames.map((name) => {
        const store = Reactor.evaluate([name]);
        if (store) {
            const storeData = JSON.stringify(store.toJS());
            try {
                sessionStorage.setItem(`${name}-store`, storeData);
            } catch (e) {
                removeOldestStudent();
                try {
                    sessionStorage.setItem(`${name}-store`, storeData);
                } catch (e) {
                    // Quota limit most likely reached.
                    console.log(`sessionStorage failed for ${name} with ${e}, deleting it`);
                    sessionStorage.removeItem(`${name}-store`, storeData);
                    // Just catch the error - browser might have other restrictions in place.
                }
            }
        }
    });
};

export const loadStores = (storesToLoad) => {
    // Can accept null (for all stores), string (store name), or array of strings (multiple store names)
    const storeNames = getStoreNames(storesToLoad);
    let storeData = {};
    storeNames.forEach((storeName) => {
        const sessionData = sessionStorage.getItem(`${storeName}-store`);
        if (sessionData) {
            const convertedData = JSON.parse(sessionData);
            storeData[storeName] = convertedData;
        } // if (sessionData)
    });
    if (Object.keys(storeData).length != 0) {
        Reactor.loadState(storeData);
    }
};

export const clearStudentData = () => {
    let sessionStorageHistoryItems = [];

    Object.keys(sessionStorage)
        .filter((key) => key.startsWith('@@History'))
        .forEach((historyItemKey) =>
            sessionStorageHistoryItems.push({ key: historyItemKey, value: sessionStorage.getItem(historyItemKey) })
        );

    let authConstant = sessionStorage.getItem("auth_session_Token");
    sessionStorage.clear();
    nweaGlobals.studentArchives = {};

    sessionStorageHistoryItems.forEach((item) => {
        sessionStorage.setItem(item.key, item.value);
    });
    sessionStorage.setItem("auth_session_Token",authConstant);
    saveStores();
};

export const saveStudentData = (studentBid) => {
    const studentData = Reactor.evaluate(StudentGetters.allDataForStudent(studentBid));
    if (!studentData) {
        console.log('Student Data not retrieved for storing. Student BID: ' + studentBid);
        return;
    }
    //console.log(`saveStudentData: ${JSON.stringify(studentData.get('normsForGrowthGoals').toJSON(), null, '\t')}`);
    if (!nweaGlobals.studentArchives) {
        nweaGlobals.studentArchives = {};
        populateArchivesFromStorage();
    }
    nweaGlobals.studentArchives[studentBid] = {
        data: studentData,
        timestamp: Date.now(),
    };
    try {
        const archive = JSON.stringify(studentData.toJS());
        sessionStorage.setItem(studentBid, archive);
    } catch (e) {
        // Quota limit most likely reached.
        removeOldestStudent();
        try {
            sessionStorage.setItem(studentBid, archive);
        } catch (e) {
            // Quota limit most likely reached.
            // Just catch the error - browser might have other restrictions in place.
        }
    }
};

export const populateArchivesFromStorage = () => {
    const studentList = Reactor.evaluate(RosterGetters.students);
    studentList.forEach((student) => {
        const studentBid = student.get('studentBid', '');
        const rawData = sessionStorage.getItem(studentBid);
        if (rawData) {
            const parsedData = toImmutable(JSON.parse(rawData));
            nweaGlobals.studentArchives[studentBid] = {
                data: parsedData,
                timestamp: Date.now(),
            };
        }
    });
};

export const loadStudentData = (studentBid) => {
    if (!__BATCH__ && window['nweaGlobals'] && nweaGlobals.studentArchives && nweaGlobals.studentArchives[studentBid]) {
        return nweaGlobals.studentArchives[studentBid].data;
    }
    const rawData = !__BATCH__ ? sessionStorage.getItem(studentBid) : null;
    if (rawData) {
        // this may need to be Immutable.fromJS(JSON.parse(rawData));
        return toImmutable(JSON.parse(rawData));
    } else {
        return null;
    }
};

export const storeExistsInSession = (storeToCheck) => {
    return !!sessionStorage.getItem(storeToCheck);
};

export default {
    USER_STORE,
    PYRON_API_BASE_PATH,
    PARTNER_STORE,
    ROSTER_STORE,
    RUNTIME_STORE,
    saveStores,
    loadStores,
    storeExistsInSession,
    saveStudentData,
    loadStudentData,
    removeOldestStudent,
    populateArchivesFromStorage,
    clearStudentData,
};
